import React from 'react';
import { Info } from 'lucide-react';

const DisclaimerBanner = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-slate-700 text-slate-200 text-xs md:text-sm py-2 px-4 text-center font-medium z-50" data-testid="disclaimer-banner">
      <div className="flex items-center justify-center gap-2">
        <Info className="h-3.5 w-3.5" />
        <span>For educational purposes. Do not enter private patient data.</span>
      </div>
    </div>
  );
};

export default DisclaimerBanner;
